module.exports = __webpack_public_path__ + "img/IMG_2024_L_BlackMatted_MockedUp.6c512ce8.jpg";